import { useEffect, useState } from "react";

import { Typography, Grid } from "@material-ui/core";

import { getData } from "../../../../services";
import BatteryIcon from "../../../../assets/images/icons/battery.svg";
import SolarIcon from "../../../../assets/images/icons/solar.svg";
import EVIcon from "../../../../assets/images/icons/ev-charge.svg";
import { IncreasePowerRevenuesRecommendation } from "./IncreasePowerRevenuesRecommendation";

const ENDPOINT = "/praas/v1/power-assets/recommendations/";
const POWER_ASSETS = [
  {
    iconSrc: EVIcon,
    label: "Install EV Chargers",
    key: "ev",
  },
  {
    iconSrc: BatteryIcon,
    label: "Install Batteries",
    key: "batteries",
  },
  {
    iconSrc: SolarIcon,
    label: "Install Solar Sys.",
    key: "solar",
  },
];

export const IncreasePowerRevenues = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    getData(ENDPOINT, (data) => {
      setData(data);
    });
  }, []);

  if (POWER_ASSETS.every((asset) => Boolean(data[asset.key]?.count) === false)) {
    return null;
  }

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item>
        <Typography variant="h4">How To Increase Power Revenues?</Typography>
      </Grid>
      <Grid container item spacing={3}>
        {POWER_ASSETS.map((asset) => {
          if (Boolean(data[asset.key]?.count) === false) {
            return null;
          }

          return (
            <Grid item md={4} key={asset.key}>
              <IncreasePowerRevenuesRecommendation
                iconSrc={asset.iconSrc}
                label={asset.label}
                numberOfRecommendations={data[asset.key]?.count}
                potentialRevenues={data[asset.key]?.estimated_revenues_potential_per_year}
              />
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};
